import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { createhostellogin, assign_assit_head_master } from "../api/Users";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import axios from "../api/constant";

const AssignAsstHeadMaster = ({ role, userData }) => {
  const { t } = useTranslation();
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [Alldistricts, setAllDistricts] = useState([]);
  const [Allblocks, setAllBlocks] = useState([]);
  const [Allvillages, setAllVillages] = useState([]);
  const [AllGPs, setAllGPs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [markRequired, setMarkRequired] = useState(true);
  const [Hostelname, setHostelname] = useState("");
  const [Emailid, setEmailid] = useState("");
  const [SchoolName, setSchoolName] = useState("");
  const [Password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [Address, setAddress] = useState("");
  const [District, setDistrict] = useState("");
  const [Village, setVillage] = useState("");
  const [schoolId, setSchoolId] = useState("");
  //   const [Role, setRole] = useState("");
  const [UDISE, setUDISE] = useState("");
  const [Block, setBlock] = useState("");
  const [GP, setGP] = useState("");
  const [number, setNumber] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [passwordMismatchError, setPasswordMismatchError] = useState("");
  //   const [gcb, setGcb] = useState([]);
  const [category, setCategory] = useState("");
  //   const [categories, setCategories] = useState([]);
  const [gbcType, setGcbType] = useState("");
  const [asstHeadMasterName, setAsstHeadMasterName] = useState("");
  const [schoolType, setSchoolType] = useState("");

  const {
    register,
    reset,
    formState: { errors },
  } = useForm();
  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const handleEmailChange = (event) => {
    setEmailid(event.target.value);
    validateEmail(event.target.value);
  };

  const handleContactNoChange = (e) => {
    setNumber(e.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (ConfirmPassword && event.target.value !== ConfirmPassword) {
      setPasswordMismatchError("Passwords do not match");
    } else {
      setPasswordMismatchError("");
    }
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    if (Password && event.target.value !== Password) {
      setPasswordMismatchError("Passwords do not match");
    } else {
      setPasswordMismatchError("");
    }
  };

  const validateEmail = (email) => {
    if (
      !(
        /^[a-zA-Z0-9._%+-]+@gmail.com$/.test(email) ||
        /^[a-zA-Z0-9._%+-]+@outlook.com$/.test(email) ||
        /^[a-zA-Z0-9._%+-]+@yahoo.com$/.test(email)
      )
    ) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  const handleNameChange = (e) => {
    setAsstHeadMasterName(e.target.value);
  };

  const handleSubmitForm = async (event, data) => {
    setIsLoading(true);
    event.preventDefault();
    if (emailError) {
      setIsLoading(false);
      toast.error("Please provide a valid email address.");
      return;
    }
    if (Password !== ConfirmPassword) {
      setIsLoading(false);
      toast.error("Passwords do not match");
      return;
    }

    if(number.length < 10 || number.length > 10) {
      setIsLoading(false);
      toast.error("Mobile No. not valid!");
      return;
    }

    const Postdata = {
      district_code: userData.data.district_code,
      block_code: userData.data.district_code,
      gp_code: userData.data.gp_code,
      village_code: userData.data.village_code,
      school_id: userData.data.school_id,
      school_name: userData.data.school_name,
      name: asstHeadMasterName,
      username: asstHeadMasterName,
      email: Emailid,
      mobile_no: number,
      password: Password,
      UDISE_code: userData.data.UDISE_code,
    };

    assign_assit_head_master(Postdata)
      .then((response) => {
        if (response.status == "success") {
          setIsLoading(false);
          toast.success(response.message);
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Error rejecting requirement:", error);
        toast.error(
          error.response?.data?.message || "Failed to reject requirement"
        );
      });
  };

  const toggleClearButton = () => {
    setBlock("");
    setSchoolType("");
    setSchoolName("");
    setSchoolId("");
    setUDISE("");
    setAsstHeadMasterName("");
    setNumber("");
    setPassword("");
    setConfirmPassword("");
    setEmailid("");
  };
  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <form
          id="myform1"
          onSubmit={(e, data) => handleSubmitForm(e, data)}
          style={{ marginTop: "12px" }}
        >
          <h5 className="my-4">{t("Assign Assistant Headmaster")}</h5>

          <div className="row">
            <div className="col-md-4">
              <label className="form-label">
                {t("District")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="district_name"
                disabled
                className="form-control"
                value={userData.data.district_name}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Block")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="block_name"
                disabled
                className="form-control"
                value={userData.data.block_name}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("GP")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="gp_name"
                disabled
                className="form-control"
                value={userData.data.gp_name}
              />
            </div>
          </div>

          <div className="row" style={{ marginTop: "12px" }}>
            <div className="col-md-4">
              <label className="form-label">
                {t("Village Name")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="village_name"
                disabled
                className="form-control"
                value={userData.data.village_name}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("School Name")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="school_name"
                disabled
                className="form-control"
                value={userData.data.school_name}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("UDISE Code")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="UDISE"
                disabled
                className="form-control"
                value={userData.data.UDISE_code}
              />
            </div>
          </div>

          <div className="row" style={{ marginTop: "12px" }}>
            <div className="col-md-4">
              <label className="form-label">
                {t("Assistant Headmaster Name")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="asst_headmaster_name"
                className="form-control"
                value={asstHeadMasterName}
                onChange={handleNameChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Assistant Headmaster Mobile Number")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="number"
                pattern="[0-9]*"
                max={9999999999}
                min={999999999}
                name="mobile_no"
                className="form-control"
                onChange={handleContactNoChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Ashram Email ID")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={Emailid}
                onChange={handleEmailChange}
                required
              />
              {emailError && <span className="text-danger">{emailError}</span>}
            </div>
          </div>
          <div
            className="row"
            style={{ marginTop: emailError ? "0px" : "12px" }}
          >
            <div className="col-md-4">
              <label className="form-label">
                {t("New Password")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <div className="input-group">
                <input
                  type={passwordVisible ? "text" : "password"}
                  name="password"
                  className={`form-control ${
                    errors.password ? "is-invalid" : ""
                  }`}
                  {...register("password", {
                    required: t("Password is required"),
                    pattern: {
                      value: strongPasswordRegex,
                      message: t(
                        "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
                      ),
                    },
                  })}
                  onChange={handlePasswordChange}
                />
                <span
                  className="input-group-text"
                  onClick={togglePasswordVisibility}
                >
                  <IconButton size="small">
                    {passwordVisible ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </span>
              </div>
              {errors.password && (
                <span className="error-text">{errors.password?.message}</span>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Confirm Password")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <div className="input-group">
                <input
                  type={confirmPasswordVisible ? "text" : "password"}
                  name="confirm_password"
                  className={`form-control ${
                    passwordMismatchError ? "is-invalid" : ""
                  }`}
                  value={ConfirmPassword}
                  onChange={handleConfirmPasswordChange}
                  required
                />
                <span
                  className="input-group-text"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  <IconButton size="small">
                    {confirmPasswordVisible ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </span>
              </div>
              {passwordMismatchError && (
                <span className="error-text">{passwordMismatchError}</span>
              )}
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary me-2">
                {t("Submit")}
              </button>
              <button
                onClick={toggleClearButton}
                type="button"
                className="btn btn-secondary"
              >
                {t("Clear")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AssignAsstHeadMaster;
